import {
  CREDENTIALS_STATUS,
  CREDENTIALS_DOC_TYPE,
  APPLICATION_MODE,
  MAX_CREDENTIALS_LICENSE_COUNT,
} from 'app/constants';

import {
  FETCH_CONSTANTS_SUCCESS,
  AGENT_PROFILE_SERVICE_COMPLETE,
  SAVE_USER_PROFILE_IN_PROGRESS_REQUEST,
  SAVE_USER_PROFILE_NEW_REQUEST,
  SAVE_USER_PROFILE_SUCCESS,
  FETCH_CURRENT_USER_PROFILE_SUCCESS,
  FETCH_CURRENT_USER_PROFILE_REQUEST,
  SAVE_COMPANY_PROFILE_REQUEST,
  SAVE_COMPANY_PROFILE_SUCCESS,
  SAVE_SERVICE_FEE_REQUEST,
  SAVE_SERVICE_FEE_SUCCESS,
  FETCH_REGION_COVERAGE_SUCCESS,
  FETCH_SLA_TARGETS_SUCCESS,
  SAVE_REGION_COVERAGE_REQUEST,
  SAVE_REGION_COVERAGE_SUCCESS,
  SAVE_PROFESSIONAL_INFO_REQUEST,
  SAVE_PROFESSIONAL_INFO_SUCCESS,
  DELETE_E_AND_O_DOCUMENT_REQUEST,
  DELETE_E_AND_O_DOCUMENT_SUCCESS,
  SAVE_E_AND_O_INFO_REQUEST,
  SAVE_E_AND_O_INFO_SUCCESS,
  SET_E_AND_O_DOCS,
  ADD_CREDENTIAL_DOCUMENTS,
  DELETE_CREDENTIAL_DOCUMENT_REQUEST,
  DELETE_CREDENTIAL_DOCUMENT_SUCCESS,
  SAVE_COMPLETE_PROFILE_SUCCESS,
  UPDATE_APPLICATION_STATUS_SUCCESS,
  UPDATE_APPLICATION_STATUS_REQUEST,
  APPROVE_APPLICATION_REQUEST,
  FETCH_APPLICATION_MESSAGE_LIST_SUCCESS,
  ADD_APPLICATION_MESSAGE_SUCCESS,
} from './agentProfileActions';

import agentProfileInitialState from './agentProfileInitialState';

const initialState = agentProfileInitialState();

const agentProfileReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CONSTANTS_SUCCESS: {
      const { constants } = payload;
      const newState = {
        ...state,
        constants: {
          APPRAISAL_METHODOLOGIES: [...constants.APPRAISAL_METHODOLOGIES],
          BUSINESS: [...constants.BUSINESS],
          CLIENT: [...constants.CLIENT],
          COMPANY_UPDATE_RESPONSIBILITY: [...constants.COMPANY_UPDATE_RESPONSIBILITY],
          DIVERSE_GROUP: [...constants.DIVERSE_GROUP],
          DOCUMENT: [...constants.DOCUMENT],
          ETHNICITY: [...constants.ETHNICITY],
          GENDER: [...constants.GENDER],
          INSURANCE: [...constants.INSURANCE],
          LICENSE: [...constants.LICENSE],
          MONTHLY_ORDERS: [...constants.MONTHLY_ORDERS],
          NUMBER_OF_CLIENTS: [...constants.NUMBER_OF_CLIENTS],
          PROPERTY: [...constants.PROPERTY],
          PROGRAM_SERVICE_GROUPS: [...constants.PROGRAM_SERVICE_GROUPS],
          YEARS_APPRAISING: [...constants.YEARS_APPRAISING],
          STATUS: [...constants.STATUS],
          TAX_ID: [...constants.TAX_ID],
          SOFTWARE: [...constants.SOFTWARE],
          SUPPORTED_FILE: [...constants.SUPPORTED_FILE],
        },
      };
      return newState;
    }

    case AGENT_PROFILE_SERVICE_COMPLETE: {
      const newState = {
        ...state,
        isCallInprogress: false,
      };
      return newState;
    }

    case UPDATE_APPLICATION_STATUS_REQUEST:
    case APPROVE_APPLICATION_REQUEST:
    case SAVE_COMPANY_PROFILE_REQUEST:
    case SAVE_USER_PROFILE_IN_PROGRESS_REQUEST:
    case SAVE_SERVICE_FEE_REQUEST:
    case SAVE_REGION_COVERAGE_REQUEST:
    case SAVE_PROFESSIONAL_INFO_REQUEST:
    case SAVE_E_AND_O_INFO_REQUEST:
    case DELETE_E_AND_O_DOCUMENT_REQUEST:
    case DELETE_CREDENTIAL_DOCUMENT_REQUEST:
    case SAVE_USER_PROFILE_NEW_REQUEST: {
      const newState = {
        ...state,
        isCallInprogress: true,
      };
      return newState;
    }

    case SAVE_USER_PROFILE_SUCCESS: {
      const { userProfile } = payload;
      const newState = {
        ...state,
        userProfile: {
          ...userProfile,
        },
      };
      return newState;
    }
    case FETCH_CURRENT_USER_PROFILE_REQUEST: {
      const { applicationId, accessToken } = payload;
      const newState = {
        ...state,
        applicationId,
        accessToken,
        isCallInprogress: true,
      };
      return newState;
    }
    case FETCH_CURRENT_USER_PROFILE_SUCCESS: {
      const { currentUser } = payload;

      const feeList = (currentUser.fees && Array.isArray(currentUser.fees)) ? [...currentUser.fees] : [];
      const feeMap = {};

      feeList.forEach((f) => {
        feeMap[f.serviceGroupId] = f;
      });

      const coverage = currentUser.coverage || {
        typicalCompletion: {},
      };

      const professionalInfo = currentUser.professionalInfo || {};

      const eo = currentUser.eo || { document: {} };

      const credentials = currentUser.credentials || { documents: [] };

      eo.documentList = eo.document && eo.document.id ? [eo.document] : [];
      const newState = {
        ...state,
        status: currentUser.status,
        isAuthenticated: true,
        userProfile: {
          ...currentUser.user,
        },
        companyProfile: {
          ...currentUser.company,
        },
        serviceGroupFees: {
          feeMap,
        },
        regionCoverage: {
          ...state.regionCoverage,
          ...coverage,
          zipCodes: (Array.isArray(coverage.zipCodes)) ? [...coverage.zipCodes] : [],
          typicalCompletion: {
            sunday: (Array.isArray(coverage.typicalCompletion.sunday)) ? [...coverage.typicalCompletion.sunday] : [],
            monday: (Array.isArray(coverage.typicalCompletion.monday)) ? [...coverage.typicalCompletion.monday] : [],
            tuesday: (Array.isArray(coverage.typicalCompletion.tuesday)) ? [...coverage.typicalCompletion.tuesday] : [],
            wednesday: (Array.isArray(coverage.typicalCompletion.wednesday)) ? [...coverage.typicalCompletion.wednesday] : [],
            thursday: (Array.isArray(coverage.typicalCompletion.thursday)) ? [...coverage.typicalCompletion.thursday] : [],
            friday: (Array.isArray(coverage.typicalCompletion.friday)) ? [...coverage.typicalCompletion.friday] : [],
            saturday: (Array.isArray(coverage.typicalCompletion.saturday)) ? [...coverage.typicalCompletion.saturday] : [],
          },
        },
        professionalInfo: {
          ...state.professionalInfo,
          ...professionalInfo,
          appraisalMethodologies: (Array.isArray(professionalInfo.appraisalMethodologies)) ? [...professionalInfo.appraisalMethodologies] : [],
          typicalProperties: (Array.isArray(professionalInfo.typicalProperties)) ? [...professionalInfo.typicalProperties] : [],
          clientMix: (Array.isArray(professionalInfo.clientMix)) ? [...professionalInfo.clientMix] : [],
          initialLicenseDate: credentials.initialLicenseDate,
          yearsAppraising: coverage.yearsAppraising,
          monthlyOrders: coverage.monthlyOrders,
        },
        credentials: {
          ...state.credentials,
          ...currentUser.credentials,
          documents: Array.isArray(currentUser.credentials.documents) ? [...currentUser.credentials.documents] : [],
        },
        eo: {
          ...state.eo,
          ...eo,
        },
      };
      return newState;
    }

    case SAVE_COMPANY_PROFILE_SUCCESS: {
      const { companyProfile } = payload;
      const newState = {
        ...state,
        companyProfile: {
          ...companyProfile,
        },
      };
      return newState;
    }

    case SAVE_SERVICE_FEE_SUCCESS: {
      const { serviceFeeList } = payload;

      const feeList = (serviceFeeList && Array.isArray(serviceFeeList)) ? [...serviceFeeList] : [];
      const feeMap = {};

      feeList.forEach((f) => {
        feeMap[f.serviceGroupId] = f;
      });

      const newState = {
        ...state,
        serviceGroupFees: {
          ...state.serviceGroupFees,
          feeMap,
        },
      };
      return newState;
    }

    case FETCH_REGION_COVERAGE_SUCCESS: {
      const { regionCoverageMap } = payload.regionCoverage;
      const coverageList = [];

      Object.keys(regionCoverageMap).sort().forEach((stateName, stateNameIndex) => {
        const countyList = [];
        Object.keys(regionCoverageMap[stateName]).sort().forEach((countyName, countyNameIndex) => {
          const cityList = [];
          Object.keys(regionCoverageMap[stateName][countyName]).sort().forEach((cityName, cityNameIndex) => {
            cityList.push({
              key: `state_${stateNameIndex}_county_${countyNameIndex}_city_${cityNameIndex}`,
              name: cityName.toLowerCase(),
              zipCodes: regionCoverageMap[stateName][countyName][cityName],
            });
          });

          countyList.push({
            key: `state_${stateNameIndex}_county_${countyNameIndex}`,
            name: countyName.toLowerCase(),
            children: cityList,
          });
        });

        coverageList.push({
          key: `state_${stateNameIndex}`,
          name: stateName.toLowerCase(),
          children: countyList,
        });
      });

      const newState = {
        ...state,
        coverageList,
      };

      return newState;
    }

    case FETCH_SLA_TARGETS_SUCCESS: {
      const { slaTargets } = payload;

      const newState = {
        ...state,
        slaTargets: {
          ...state.slaTargets,
          tat: slaTargets.tat.target,
        },
      };
      return newState;
    }

    case SAVE_REGION_COVERAGE_SUCCESS: {
      const { regionCoverage } = payload;
      const newState = {
        ...state,
        regionCoverage: {
          ...state.regionCoverage,
          ...regionCoverage,
          zipCodes: (Array.isArray(regionCoverage.zipCodes)) ? [...regionCoverage.zipCodes] : [],
          typicalCompletion: {
            sunday: (Array.isArray(regionCoverage.typicalCompletion.sunday)) ? [...regionCoverage.typicalCompletion.sunday] : [],
            monday: (Array.isArray(regionCoverage.typicalCompletion.monday)) ? [...regionCoverage.typicalCompletion.monday] : [],
            tuesday: (Array.isArray(regionCoverage.typicalCompletion.tuesday)) ? [...regionCoverage.typicalCompletion.tuesday] : [],
            wednesday: (Array.isArray(regionCoverage.typicalCompletion.wednesday)) ? [...regionCoverage.typicalCompletion.wednesday] : [],
            thursday: (Array.isArray(regionCoverage.typicalCompletion.thursday)) ? [...regionCoverage.typicalCompletion.thursday] : [],
            friday: (Array.isArray(regionCoverage.typicalCompletion.friday)) ? [...regionCoverage.typicalCompletion.friday] : [],
            saturday: (Array.isArray(regionCoverage.typicalCompletion.saturday)) ? [...regionCoverage.typicalCompletion.saturday] : [],
          },
        },
      };
      return newState;
    }

    case SAVE_PROFESSIONAL_INFO_SUCCESS: {
      const { professionalInfo } = payload.professionalInfo;
      const newState = {
        ...state,
        professionalInfo: {
          ...state.professionalInfo,
          ...professionalInfo,
          appraisalMethodologies: (Array.isArray(professionalInfo.appraisalMethodologies)) ? [...professionalInfo.appraisalMethodologies] : [],
          typicalProperties: (Array.isArray(professionalInfo.typicalProperties)) ? [...professionalInfo.typicalProperties] : [],
          clientMix: (Array.isArray(professionalInfo.clientMix)) ? [...professionalInfo.clientMix] : [],
        },
      };
      return newState;
    }

    case SAVE_E_AND_O_INFO_SUCCESS: {
      const { eandoInfo } = payload;
      const newState = {
        ...state,
        eo: {
          ...state.eo,
          ...eandoInfo,
        },
      };
      return newState;
    }

    case DELETE_E_AND_O_DOCUMENT_SUCCESS: {
      const { documentId } = payload;
      const newState = {
        ...state,
        eo: {
          ...state.eo,
          documentList: state.eo.documentList.filter(d => d.id !== documentId),
        },
      };
      return newState;
    }

    case SET_E_AND_O_DOCS: {
      const { documentList } = payload;
      const newState = {
        ...state,
        eo: {
          ...state.eo,
          documentList: [...documentList],
        },
      };
      return newState;
    }

    case ADD_CREDENTIAL_DOCUMENTS: {
      const { documentList } = payload;

      const documents = [...state.credentials.documents.concat(documentList)];
      const hasMaxLicenseCount = documents.filter(d => d.type === CREDENTIALS_DOC_TYPE.LICENSE).length >= MAX_CREDENTIALS_LICENSE_COUNT;

      let hasLicense = false;
      let hasW9 = false;
      let hasProfilePhoto = false;

      documents.forEach((d) => {
        if (d.type === CREDENTIALS_DOC_TYPE.LICENSE) {
          hasLicense = true;
        }
        if (d.type === CREDENTIALS_DOC_TYPE.W9) {
          hasW9 = true;
        }
        if (d.type === CREDENTIALS_DOC_TYPE.APPRAISER_PHOTO) {
          hasProfilePhoto = true;
        }
      });

      const credentialsStatus = (hasLicense && hasW9) ? CREDENTIALS_STATUS.SUCCESS : CREDENTIALS_STATUS.INFO;

      const newState = {
        ...state,
        credentials: {
          ...state.credentials,
          documents,
        },
        credentialProgress: {
          credentialsStatus,
          section: {
            hasMaxLicenseCount,
            hasLicense,
            hasW9,
            hasProfilePhoto,
          },
        },
      };
      return newState;
    }

    case DELETE_CREDENTIAL_DOCUMENT_SUCCESS: {
      const { documentId } = payload;
      const documents = state.credentials.documents.filter(d => d.id !== documentId);

      let hasLicense = false;
      let hasW9 = false;
      let hasProfilePhoto = false;
      const hasMaxLicenseCount = documents.filter(d => d.type === CREDENTIALS_DOC_TYPE.LICENSE).length >= MAX_CREDENTIALS_LICENSE_COUNT;

      documents.forEach((d) => {
        if (d.type === CREDENTIALS_DOC_TYPE.LICENSE) {
          hasLicense = true;
        }
        if (d.type === CREDENTIALS_DOC_TYPE.W9) {
          hasW9 = true;
        }
        if (d.type === CREDENTIALS_DOC_TYPE.APPRAISER_PHOTO) {
          hasProfilePhoto = true;
        }
      });

      const credentialsStatus = (hasLicense && hasW9) ? CREDENTIALS_STATUS.SUCCESS : CREDENTIALS_STATUS.INFO;

      const newState = {
        ...state,
        credentials: {
          ...state.credentials,
          documents,
        },
        credentialProgress: {
          credentialsStatus,
          section: {
            hasMaxLicenseCount,
            hasLicense,
            hasW9,
            hasProfilePhoto,
          },
        },
      };

      return newState;
    }

    case SAVE_COMPLETE_PROFILE_SUCCESS: {
      const newState = {
        ...state,
        status: APPLICATION_MODE.PENDING_REVIEW,
      };
      return newState;
    }

    case UPDATE_APPLICATION_STATUS_SUCCESS: {
      const { status } = payload;
      const newState = {
        ...state,
        status,
      };
      return newState;
    }

    case FETCH_APPLICATION_MESSAGE_LIST_SUCCESS: {
      const messageList = payload.messageList.data;
      const newState = {
        ...state,
        messageList,
      };

      return newState;
    }

    case ADD_APPLICATION_MESSAGE_SUCCESS: {
      const newMessage = payload.newMessage.data;
      const { messageList } = state;
      messageList.unshift(newMessage);
      const newState = {
        ...state,
        messageList,
      };
      return newState;
    }

    default:
      return state;
  }
};


export default agentProfileReducer;
